import { useRef } from 'react';
import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useNative } from '../../../../hooks/native/use-native';
import { useRestClient } from '../../../../utils/clients/rest-client';
import { BatchControlBatchData } from '../../types/openapi/openapi-types';
import { ActionBatchBody } from './action.types';

export const useActionBatch = () => {
  const abortControllerRef = useRef<AbortController | null>(null);
  const restClient = useRestClient();
  const { handleRestErrors } = useErrors();
  const { fireVibration } = useNative();

  return useMutation<AxiosResponse<BatchControlBatchData>, AxiosError<void>, ActionBatchBody>(
    ['action-batch'],
    async (body) => {
      fireVibration();
      if (abortControllerRef.current) abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();

      return await restClient.post<BatchControlBatchData>('/batchControl/batch', body, {
        signal: abortControllerRef.current.signal,
      });
    },
    {
      onError: (error) => {
        handleRestErrors(error);
      },
    },
  );
};
